export const PAGE_CHANGED = "tacker_page_changed";
export const BEFORE_PAGE_CHANGE = "tacker_before_page_change";
